import React, { MouseEventHandler, useEffect } from 'react';
import Message, { THEME } from '@mos-cat/message';
import { connect } from 'dva';
import { Heading, Paragraph } from '@mos-cat/typography';
import { createStructuredSelector } from 'reselect';

import { missingAddressInfo } from '../../../../selectors/addressUnmodeled';
import './style.pcss';
import {
  AddressMissingDataInformerStats,
  sendStats,
} from '../../../../helpers/stats';
import { sendCMABusinessError } from '../../../../helpers/CMAstats';

interface DispatchProps {
  toggleManualInput: MouseEventHandler;
}

interface StateProps {
  isMissingAddressInfo: boolean;
}

interface OwnProps {
  model: 'applicant' | 'spouse' | 'child';
}

type Props = StateProps & OwnProps & DispatchProps;

function AddressMissingDataInformer(props: Props): JSX.Element | null {
  const { toggleManualInput, isMissingAddressInfo } = props;
  useEffect(() => {
    if (isMissingAddressInfo) {
      sendStats(AddressMissingDataInformerStats());
      sendCMABusinessError('step');
    }
  }, [isMissingAddressInfo]);
  if (!isMissingAddressInfo) return null;
  return (
    <>
      <div className="PguFormGrid__row">
        <Message theme={THEME.ATTENTION} className="AddressMessage">
          <Heading level={5} className="AddressMessage__header">
            Введите адрес вручную
          </Heading>
          Для вашего адреса в системе отсутствует округ или район.{' '}
          <button
            type="button"
            className="mos-link"
            onClick={toggleManualInput}
          >
            Введите их вручную
          </button>
        </Message>
      </div>
    </>
  );
}

function mapDispatchToProps(dispatch, { model }): DispatchProps {
  return {
    toggleManualInput() {
      dispatch({
        type: `${model}/address/toggle/manualInput`,
        payload: { save_address: true },
      });
    },
  };
}

const mapStateToProps = createStructuredSelector({
  isMissingAddressInfo: missingAddressInfo,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressMissingDataInformer);
